import { useEffect, useState } from "react";
import PeopleIcon from "@mui/icons-material/People";
import StatisticsService from "../../../services/statistics.service";
import StatCard from "./StatCard";

export default function ActiveMembershipsStat() {
  const [value, setValue] = useState(null);
  const [description, setDescription] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    StatisticsService.getTotalActiveMemberships().then(({ data, description, error }) => {
      if (error) setError(error);
      else {
        setValue(data);
        setDescription(description);
      }
    });
  }, []);

  return (
    <StatCard
      icon={PeopleIcon}
      value={value}
      label="Total de usuarios con membresía activa"
      description={description}
      error={error}
      iconColor="primary.main"
    />
  );
}
